import fetch, { METHOD } from '../fetch'

export const sendMessage = async (payload) => {
  const { status } = await fetch(METHOD.POST, '/faq/send-message', payload)
  return status
}
